module.exports = __webpack_public_path__ + "img/park-solid-transaction.63c77bf0.svg";